import $ from 'jquery';

document.addEventListener( 'DOMContentLoaded', () => {
	const MOBILE_MAX = 1023;
	const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	function isMobile() {
		return window.innerWidth <= MOBILE_MAX;
	}

	$( '.sidebar-nav' ).each( function () {
		const $nav = $( this );

		$nav.find( '.sidebar-nav__item--has-children' ).each( function () {
			const $item   = $( this );
			const $toggle = $item.find( '.sidebar-nav__sub-toggle' );
			const $sub    = $item.find( '.sidebar-nav__sub-list' );

			function syncState() {
				if ( ! isMobile() ) {
					// Desktop: always show sub-list, reset any JS-applied inline styles
					$sub.removeAttr( 'style' );
					$toggle.attr( 'aria-expanded', 'false' );
					$item.removeClass( 'is-open' );
				} else if ( $toggle.attr( 'aria-expanded' ) !== 'true' ) {
					$sub.hide();
				}
			}

			$toggle.on( 'click', function () {
				if ( ! isMobile() ) return;

				const isOpen = $toggle.attr( 'aria-expanded' ) === 'true';

				if ( ! isOpen ) {
					$toggle.attr( 'aria-expanded', 'true' );
					$item.addClass( 'is-open' );
					reduceMotion ? $sub.show() : $sub.stop( true, true ).slideDown( 250 );
				} else {
					$toggle.attr( 'aria-expanded', 'false' );
					$item.removeClass( 'is-open' );
					reduceMotion ? $sub.hide() : $sub.stop( true, true ).slideUp( 250 );
				}
			} );

			$( window ).on( 'resize.sidebar-nav', syncState );
			syncState();
		} );
	} );
} );
